module.exports = __webpack_public_path__ + "static/img/no_news.383133a.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/no_news.png
// module id = syQ/
// module chunks = 37